import { render } from "./ProfileHeaderWithoutAdditionalData.vue?vue&type=template&id=02ec0910"
import script from "./ProfileHeaderWithoutAdditionalData.vue?vue&type=script&lang=js"
export * from "./ProfileHeaderWithoutAdditionalData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__